import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from 'react';
import { useStore } from 'zustand';
import { createRunStore } from './run-store';
const RunStoreContext = createContext(null);
/**
 * Shares one conversation's run store with everything under it, so a panel rendered away from the
 * chat (a side panel, a canvas overlay) reads the same run the chat is streaming.
 */
export function RelayChatProvider({ store, children }) {
    const [own] = useState(() => store ?? createRunStore());
    return _jsx(RunStoreContext.Provider, { value: store ?? own, children: children });
}
export function useRunStoreApi() {
    const store = useContext(RunStoreContext);
    if (!store)
        throw new Error('useRunStoreApi must be used inside a RelayChatProvider');
    return store;
}
/** The provider's store, or `null` outside one, for components that render with or without it. */
export function useOptionalRunStoreApi() {
    return useContext(RunStoreContext);
}
export function useRunStore(selector) {
    return useStore(useRunStoreApi(), selector);
}
